/* ============================================================
   Wick Street Vinyl — Neon Skull theme JS
   ============================================================ */
(function () {
  'use strict';
  var WSV = window.WSV || { moneyFormat: '${{amount}}', routes: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || WSV.moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var match = format.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  /* ---------- Overlay & panels ---------- */
  var overlay = $('[data-overlay]');
  var openPanel = null;

  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }

  function show(panel) {
    if (!panel) return;
    if (openPanel && openPanel !== panel) hide(openPanel);
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-active');
    lockScroll(true);
    openPanel = panel;
  }
  function hide(panel) {
    if (!panel) return;
    panel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-active');
    lockScroll(false);
    if (openPanel === panel) openPanel = null;
  }

  // Reveal panels for CSS control (they ship with [hidden] to avoid flash).
  $$('[data-cart-drawer],[data-search-drawer],[data-mobile-menu],[data-overlay]').forEach(function (el) {
    el.removeAttribute('hidden');
  });

  if (overlay) overlay.addEventListener('click', function () { if (openPanel) hide(openPanel); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openPanel) hide(openPanel); });

  /* ---------- Mobile menu ---------- */
  var mobileMenu = $('[data-mobile-menu]');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { show(mobileMenu); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { hide(mobileMenu); }); });

  /* ---------- Search drawer + predictive ---------- */
  var searchDrawer = $('[data-search-drawer]');
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      show(searchDrawer);
      var input = $('[data-predictive-input]');
      if (input) setTimeout(function () { input.focus(); }, 80);
    });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { hide(searchDrawer); }); });

  var pInput = $('[data-predictive-input]');
  var pResults = $('[data-predictive-results]');
  if (pInput && pResults) {
    var t;
    pInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = pInput.value.trim();
      if (q.length < 2) { pResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        var base = (WSV.routes.predictive || WSV.routes.search + '/suggest' || '/search/suggest');
        var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { pResults.innerHTML = '<p style="color:var(--color-text-muted)">No matches.</p>'; return; }
            pResults.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '<span>' + p.title + '</span></a>';
            }).join('');
          })
          .catch(function () { pResults.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var onCartPage = document.body.classList.contains('template-cart');
  var useDrawer = WSV.cartType !== 'page';

  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (useDrawer && cartDrawer) { e.preventDefault(); show(cartDrawer); }
    });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { hide(cartDrawer); }); });

  function getCart() {
    return fetch(WSV.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  var lastCount = parseInt(($('[data-cart-count]') || {}).textContent, 10);
  if (isNaN(lastCount)) lastCount = null;
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    // Bump the cart icon whenever something new lands in the cart
    if (lastCount !== null && count > lastCount) {
      $$('.header__cart').forEach(function (el) {
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
        setTimeout(function () { el.classList.remove('is-bump'); }, 700);
      });
    }
    lastCount = count;
  }

  function renderDrawer(cart) {
    if (!cartDrawer) return;
    updateCount(cart.item_count);
    var body = $('[data-cart-body]', cartDrawer);
    var footer = $('[data-cart-footer]', cartDrawer);
    var subtotal = $('[data-cart-subtotal]', cartDrawer);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    // v179 — total saved by discounts (the row ships hidden; see snippets/cart-drawer.liquid)
    var savings = $('[data-cart-savings]', cartDrawer);
    if (savings) {
      var saved = cart.total_discount || 0;
      var savedAmt = $('[data-cart-savings-amount]', savings);
      if (savedAmt) savedAmt.textContent = formatMoney(saved);
      if (saved > 0 && cart.item_count > 0) savings.removeAttribute('hidden'); else savings.setAttribute('hidden', '');
    }
    if (cart.item_count === 0) {
      if (footer) footer.setAttribute('hidden', '');
      if (body) body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="' + WSV.routes.cart + '" class="button">Continue shopping</a></div>';
      return;
    }
    if (footer) footer.removeAttribute('hidden');
    if (!body) return;
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    var TAG_ICON = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>';
    var items = cart.items.map(function (item) {
      var props = item.properties || {};
      // WSV builder contract: _gs_edit_url (explicit) > "Edit / view" (the builder writes its own
      // instance-correct URL, e.g. /apps/uv-gang-sheet?edit=…) > landing-page fallback.
      var gsPrev = props._gs_preview, gsUrl = props._gs_edit_url || props['Edit / view'], gsId = props._gs_design_id;
      var imgSrc = gsPrev || item.image;
      var img = imgSrc ? '<img src="' + esc(imgSrc) + '" alt="" width="80" height="80" loading="lazy">' : '<div class="cart-item__placeholder"></div>';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '';
      var visible = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && k !== 'Edit / view' && props[k]; }).map(function (k) { return '<li>' + esc(k) + ': ' + esc(props[k]) + '</li>'; }).join('');
      var extras = visible ? '<ul class="li-props" role="list">' + visible + '</ul>' : '';
      if (gsUrl || gsId) {
        var editUrl = gsUrl || ('/pages/build-a-gang-sheet?gs_design=' + encodeURIComponent(gsId) + '&gs_line=' + encodeURIComponent(item.key) + '&gs_qty=' + item.quantity);
        extras += '<a class="li-edit" href="' + esc(editUrl) + '">&#9998; Edit design</a>';
      }
      // v179 — old price struck through + the name of each discount on this line (same markup as the Liquid drawer)
      var was = item.original_line_price > item.final_line_price ? '<s class="cart-item__was">' + formatMoney(item.original_line_price) + '</s> ' : '';
      var allocs = item.line_level_discount_allocations || [];
      var discounts = allocs.length ? '<ul class="cart-item__discounts" role="list">' + allocs.map(function (a) {
        var title = (a.discount_application && a.discount_application.title) || 'Discount';
        return '<li>' + TAG_ICON + '<span>' + esc(title) + ' (&minus;' + formatMoney(a.amount) + ')</span></li>';
      }).join('') + '</ul>' : '';
      return '<li class="cart-item" data-cart-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-item__media">' + img + '</a>' +
        '<div class="cart-item__details">' +
        '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' + variant + extras +
        '<div class="cart-item__row"><div class="qty qty--sm" data-line-qty>' +
        '<button type="button" class="qty__btn" data-line-minus data-key="' + item.key + '">&minus;</button>' +
        '<input type="number" class="qty__input" value="' + item.quantity + '" min="0" data-line-input data-key="' + item.key + '">' +
        '<button type="button" class="qty__btn" data-line-plus data-key="' + item.key + '">+</button></div>' +
        '<span class="cart-item__price">' + was + formatMoney(item.final_line_price) + '</span></div>' + discounts +
        '<button type="button" class="cart-item__remove" data-line-remove data-key="' + item.key + '">Remove</button>' +
        '</div></li>';
    }).join('');
    body.innerHTML = '<ul class="cart-items" data-cart-items role="list">' + items + '</ul>';
  }

  function refreshCart(openIt) {
    return getCart().then(function (cart) {
      renderDrawer(cart);
      if (openIt && useDrawer) show(cartDrawer);
      return cart;
    });
  }

  function changeLine(key, qty) {
    return fetch(WSV.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // Delegated cart line controls (works in drawer and cart page)
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-line-minus]');
    var plus = e.target.closest('[data-line-plus]');
    var remove = e.target.closest('[data-line-remove]');
    var target = minus || plus || remove;
    if (!target) return;
    var key = target.getAttribute('data-key');
    var row = target.closest('[data-cart-item]');
    var input = row ? $('[data-line-input]', row) : null;
    var current = input ? parseInt(input.value, 10) : 1;
    var next = remove ? 0 : (plus ? current + 1 : Math.max(0, current - 1));
    changeLine(key, next).then(function () {
      if (onCartPage) { window.location.reload(); }
      else { refreshCart(false); }
    });
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.getAttribute('data-key'), qty).then(function () {
      if (onCartPage) { window.location.reload(); } else { refreshCart(false); }
    });
  });

  /* ---------- Quick add (cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch(WSV.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshCart(true); })
      .then(function () { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); })
      .catch(function () { btn.textContent = original; })
      .finally(function () { setTimeout(function () { btn.disabled = false; btn.textContent = original; btn.classList.remove('is-added'); }, 1200); });
  });

  /* ---------- Product page ---------- */
  var productForm = $('[data-product-form]');
  if (productForm) {
    var variants = [];
    try { variants = JSON.parse($('[data-variant-json]', productForm).textContent); } catch (e) {}
    var variantSelect = $('[data-variant-select]', productForm);
    var priceWrap = $('[data-price-wrap]') || $('[data-price-wrap]', document);
    var addBtn = $('[data-add-btn]', productForm);
    var addText = $('[data-add-text]', productForm);
    var mainImg = $('#ProductMainImage');

    function selectedOptions() {
      var groups = $$('.product__option', productForm);
      return groups.map(function (g) {
        var checked = $('input[data-option-value]:checked', g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      if (opts.indexOf(null) !== -1 && opts.length > 0 && $$('.product__option', productForm).length) {
        // not all selected; fall through using first match attempt
      }
      var v = findVariant(opts) || variants[0];
      if (!v) return;
      if (variantSelect) variantSelect.value = v.id;
      if (priceWrap) {
        var html = '<div class="price' + (v.compare_at_price > v.price ? ' price--on-sale' : '') + '">';
        html += '<span class="price__current">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<s class="price__was">' + formatMoney(v.compare_at_price) + '</s>';
        html += '</div>';
        priceWrap.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        swapMain(v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2'));
      }
    }
    // Crossfade the main image instead of hard-swapping it
    function swapMain(src) {
      if (!mainImg || !src || mainImg.getAttribute('src') === src) return;
      mainImg.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        mainImg.src = src;
        requestAnimationFrame(function () { mainImg.classList.remove('is-swapping'); });
      };
      pre.src = src;
    }
    $$('input[data-option-value]', productForm).forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // AJAX add to cart from product page
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(productForm);
      if (addBtn) { addBtn.disabled = true; }
      if (addText) { addText.textContent = 'Adding…'; }
      fetch(WSV.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { throw new Error(data.description || 'Error'); }
          return refreshCart(true);
        })
        .then(function () { if (addText) addText.textContent = 'Added ✓'; })
        .catch(function () { if (addText) addText.textContent = 'Unavailable'; })
        .finally(function () {
          setTimeout(function () { if (addBtn) addBtn.disabled = false; if (addText) addText.textContent = 'Add to cart'; }, 1400);
        });
    });

    // Quantity steppers
    var qInput = $('[data-qty-input]', productForm);
    $('[data-qty-plus]', productForm) && $('[data-qty-plus]', productForm).addEventListener('click', function () { qInput.value = (parseInt(qInput.value, 10) || 1) + 1; });
    $('[data-qty-minus]', productForm) && $('[data-qty-minus]', productForm).addEventListener('click', function () { qInput.value = Math.max(1, (parseInt(qInput.value, 10) || 1) - 1); });

    // Thumbnails
    $$('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        swapMain(full);
        $$('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    updateVariant();

    // Sticky add-to-cart bar on phones/tablets: appears once the real button scrolls off
    (function () {
      if (!addBtn || !('IntersectionObserver' in window)) return;
      var mq = window.matchMedia ? window.matchMedia('(max-width: 990px)') : null;
      var bar = document.createElement('div');
      bar.className = 'wsv-sticky-atc';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<div class="wsv-sticky-atc__info"><span class="wsv-sticky-atc__title"></span><span class="wsv-sticky-atc__price"></span></div><button type="button" class="button wsv-sticky-atc__btn"></button>';
      var titleEl = $('.product__title');
      var titleText = '';
      if (titleEl) { Array.prototype.forEach.call(titleEl.childNodes, function (n) { if (n.nodeType === 3) titleText += n.textContent; }); }
      $('.wsv-sticky-atc__title', bar).textContent = (titleText.trim() || document.title);
      document.body.appendChild(bar);
      var sBtn = $('.wsv-sticky-atc__btn', bar), sPrice = $('.wsv-sticky-atc__price', bar);
      function sync() {
        sBtn.disabled = addBtn.disabled;
        sBtn.textContent = addText ? addText.textContent : 'Add to cart';
        var p = priceWrap ? $('.price__current', priceWrap) : null;
        sPrice.textContent = p ? p.textContent : '';
      }
      sync();
      if ('MutationObserver' in window) {
        new MutationObserver(sync).observe(productForm, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        if (priceWrap) new MutationObserver(sync).observe(priceWrap, { subtree: true, childList: true, characterData: true });
      }
      sBtn.addEventListener('click', function () {
        if (productForm.requestSubmit) productForm.requestSubmit(); else addBtn.click();
      });
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var showIt = !en.isIntersecting && en.boundingClientRect.top < 0 && (!mq || mq.matches);
        bar.classList.toggle('is-visible', showIt);
        bar.setAttribute('aria-hidden', showIt ? 'false' : 'true');
        document.body.classList.toggle('has-sticky-atc', showIt);
      }, { threshold: 0 });
      io.observe(addBtn);
    })();
  }

  /* ---------- Collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Slideshow (autoplay, arrows, dots, swipe, per-slide motion) ---------- */
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('[data-slides]', root);
    var slides = $$('[data-slide]', root);
    if (!track || !slides.length) return;
    root.classList.add('is-ready');
    slides[0].classList.add('is-active');
    if (slides.length < 2) return;
    var dots = $$('[data-slide-dot]', root);
    var index = 0, timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.classList.remove('is-dragging');
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    function start() { if (autoplay) { stop(); timer = setInterval(function () { go(index + 1); }, speed); } }
    function stop() { if (timer) clearInterval(timer); }

    $('[data-slide-next]', root) && $('[data-slide-next]', root).addEventListener('click', function () { go(index + 1); start(); });
    $('[data-slide-prev]', root) && $('[data-slide-prev]', root).addEventListener('click', function () { go(index - 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-dot'), 10)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Swipe / drag (touch, pen or mouse). Vertical moves are left to the browser (touch-action: pan-y).
    if (window.PointerEvent) {
      var sx = 0, sy = 0, dx = 0, dragging = false, moved = false, w = 1;
      root.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('button')) return;
        sx = e.clientX; sy = e.clientY; dx = 0; dragging = true; moved = false;
        w = root.clientWidth || 1;
        stop();
      });
      root.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - sx;
        var dy = e.clientY - sy;
        if (!moved && Math.abs(dy) > Math.abs(dx)) return;
        if (Math.abs(dx) > 6) {
          moved = true;
          track.classList.add('is-dragging');
          track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))';
        }
      });
      function endDrag() {
        if (!dragging) return;
        dragging = false;
        var min = Math.min(60, w * 0.15);
        if (dx < -min) go(index + 1); else if (dx > min) go(index - 1); else go(index);
        if (moved) { root.classList.add('is-swiped'); setTimeout(function () { root.classList.remove('is-swiped'); }, 350); }
        start();
      }
      root.addEventListener('pointerup', endDrag);
      root.addEventListener('pointercancel', endDrag);
      root.addEventListener('pointerleave', endDrag);
      root.addEventListener('click', function (e) { if (root.classList.contains('is-swiped')) { e.preventDefault(); e.stopPropagation(); } }, true);
      root.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    go(0); start();
  });

  /* ---------- Scroll reveal + loyalty count-up ---------- */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.section__head, .wsv-tiers__header, .promo, .coll-card, .card-wrapper, .testimonial, .wsv-tiers__card, .wsv-trust__item, .gs-card, .gs-panel, .wsv-policy, .wsv-rewards-tier, .wsv-rewards-how__step, .wsv-review-card, .wsv-acc__item, .image-with-text__media, .image-with-text__content';
    var els = $$(SEL);
    if (!els.length) return;
    els.forEach(function (el) {
      var idx = 0, prev = el.previousElementSibling;
      while (prev) { if (prev.matches && prev.matches(SEL)) idx++; prev = prev.previousElementSibling; }
      el.style.setProperty('--rvd', (Math.min(idx, 6) * 80) + 'ms');
      el.classList.add('wsv-rv');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });

    var counts = $$('.wsv-tiers__count');
    if (counts.length) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          cio.unobserve(en.target);
          var el = en.target;
          var target = parseInt(String(el.textContent).replace(/[^0-9]/g, ''), 10);
          if (!target || target < 2) return;
          var start = null, dur = 1300;
          function stepFn(ts) {
            if (!start) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(target * eased).toLocaleString();
            if (p < 1) requestAnimationFrame(stepFn);
          }
          requestAnimationFrame(stepFn);
        });
      }, { threshold: 0.4 });
      counts.forEach(function (el) { cio.observe(el); });
    }
  })();

  /* ---------- Back to top ---------- */
  (function () {
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'wsv-top'; btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(btn);
    var on = false;
    function check() {
      var want = window.scrollY > Math.max(700, window.innerHeight * 1.3);
      if (want !== on) { on = want; btn.classList.toggle('is-visible', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
    btn.addEventListener('click', function () {
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      try { window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, 0); }
    });
  })();

  /* ---------- Glass header on scroll ---------- */
  (function () {
    var header = $('[data-header]');
    if (!header) return;
    var on = false;
    function check() {
      var want = window.scrollY > 24;
      if (want !== on) { on = want; header.classList.toggle('is-glass', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

})();
